// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderDetailCancelButton_container__18_W4","text":"OrderDetailCancelButton_text__3Ti8G","text-ltr":"OrderDetailCancelButton_text-ltr__3ckxn"};